module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_01_6DB79_1SB_GJ0.043d38a7.png";